exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.video-js {\n  width: 100%;\n}\n.vjs-big-play-button {\n  display: none !important;\n}\n.video-js.vjs-ended .vjs-big-play-button {\n    display: none !important;\n}\n.carousel-item {\n  background: white !important;\n}\n.carousel-control-prev{\n  display: none;\n}\n", ""]);

// exports
